import { buildCourseSlice } from "data/utils/buildSlice";
import { courseDataThunk } from "data/utils/thunks";

const key = "roster";
export const slice = buildCourseSlice(key);
export const { reducer: roster } = slice;
export const fetchRoster = courseDataThunk(key, slice);
